import {FindOneProductPayloadDto} from '@features/product/application/use_cases/find-one-product/dto/find-one-product.payload.dto';
import {FindOneProductResponseDto} from '@features/product/application/use_cases/find-one-product/dto/find-one-product.response.dto';
import {FindOneProductHttpPayloadDto} from '@features/product/infrastructure/http/find-one-product/find-one-product.http.payload.dto';
import {FindOneProductHttpResponseDto} from '@features/product/infrastructure/http/find-one-product/find-one-product.http.response.dto';

export class FindOneProductHttpMapper {

  static toResponse(data: FindOneProductHttpResponseDto): FindOneProductResponseDto {
    return {};
  }

  static toInfra(data: FindOneProductPayloadDto): FindOneProductHttpPayloadDto {
    return {};
  }

}
